import { Component, OnInit } from '@angular/core';
import { CongresosService, UserService } from '../../services/services.index';
import { Congreso } from '../../models/congreso.model';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.css']
})
export class DashboardAdminComponent implements OnInit {

  congreso: Congreso;
  totalIscriptos: number;
  totalAprobados: number;
  totalTrabajosPresentados: number;
  totalTrabajosAprobados: number;

  loading: boolean = true;

  constructor(public _congresosService: CongresosService, public _userService: UserService) { }

  ngOnInit() {
    this.cargarCongreso();
  }

  cargarCongreso() {
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        this._userService.getCantidadTotalInscriptos(this.congreso._id).subscribe((respInscriptos: any) => {
          this.totalIscriptos = respInscriptos.total;
        });
        this._userService.getCantidadInscriptosAprobados(this.congreso._id).subscribe((respInscriptosAprobados: any) => {
          this.totalAprobados = respInscriptosAprobados.total;
        });
        this._userService.getCantidadTrabajosPresentados(this.congreso._id).subscribe((respCatPresentados: any) => {
          this.totalTrabajosPresentados = respCatPresentados.total;
        });
        this._userService.getCantidadTrabajosAprobados(this.congreso._id).subscribe((respCatAprobados: any) => {
          this.totalTrabajosAprobados = respCatAprobados.total;
        });
        this.loading = false;
      }

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-admin/dashboard-admin.component.ts